/*
  Photo viewer for [data-ed-lightbox] containers.

  Progressive enhancement: the section renders real <a href="{full-res}">
  anchors, so the photos are reachable before (and without) this script. Here
  we intercept the click and show a native <dialog>, which gives us the top
  layer, Esc-to-close and a modal focus scope for free — no hand-rolled trap.

  Re-runs on shopify:section:load so the theme editor keeps working, and every
  container is bound once (data-ed-lightbox-bound).
*/
(function () {
  var DIALOG_ID = 'EdLightboxDialog';

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function lightboxLabels() {
    var i18n = window.__edLightboxI18n || {};
    return {
      prev: i18n.prev || 'Previous photo',
      next: i18n.next || 'Next photo',
      close: i18n.close || 'Close photo viewer'
    };
  }

  function buildDialog() {
    var dialog = document.getElementById(DIALOG_ID);
    if (dialog) return dialog;

    var labels = lightboxLabels();
    dialog = document.createElement('dialog');
    dialog.id = DIALOG_ID;
    dialog.className = 'ed-lightbox';
    dialog.setAttribute('aria-label', dialog.dataset.label || 'Photo viewer');
    dialog.innerHTML = [
      '<div class="ed-lightbox__frame">',
      '<img class="ed-lightbox__img" alt="">',
      '<div class="ed-lightbox__bar">',
      '<button type="button" class="ed-lightbox__btn" data-ed-lb="prev" aria-label="' + escapeAttr(labels.prev) + '">&#8592;</button>',
      '<span class="ed-lightbox__meta" aria-live="polite">',
      '<span data-ed-lb="caption"></span> <span class="ed-lightbox__count" data-ed-lb="count"></span>',
      '</span>',
      '<button type="button" class="ed-lightbox__btn" data-ed-lb="next" aria-label="' + escapeAttr(labels.next) + '">&#8594;</button>',
      '</div>',
      '<button type="button" class="ed-lightbox__btn ed-lightbox__close" data-ed-lb="close" aria-label="' + escapeAttr(labels.close) + '">&#215;</button>',
      '</div>'
    ].join('');
    document.body.appendChild(dialog);
    return dialog;
  }

  function LightboxController(dialog) {
    this.dialog = dialog;
    this.img = dialog.querySelector('.ed-lightbox__img');
    this.caption = dialog.querySelector('[data-ed-lb="caption"]');
    this.count = dialog.querySelector('[data-ed-lb="count"]');
    this.items = [];
    this.index = 0;
    this.invoker = null;

    var self = this;
    dialog.addEventListener('click', function (event) {
      var action = event.target.closest('[data-ed-lb]');
      if (action) {
        var kind = action.getAttribute('data-ed-lb');
        if (kind === 'next') self.step(1);
        if (kind === 'prev') self.step(-1);
        if (kind === 'close') dialog.close();
        return;
      }
      // Click outside the image closes, matching the zoom-out cursor.
      if (!event.target.closest('.ed-lightbox__frame') || event.target === self.img) {
        dialog.close();
      }
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.step(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.step(-1);
      }
    });

    dialog.addEventListener('close', function () {
      // Return focus to the thumbnail the viewer was opened from.
      if (self.invoker && document.contains(self.invoker)) self.invoker.focus();
      self.invoker = null;
      self.img.removeAttribute('src');
    });
  }

  LightboxController.prototype.open = function (items, index, invoker) {
    this.items = items;
    this.invoker = invoker || null;
    if (typeof this.dialog.showModal !== 'function') return false;
    this.show(index);
    this.dialog.showModal();
    return true;
  };

  LightboxController.prototype.show = function (index) {
    var total = this.items.length;
    if (!total) return;
    this.index = ((index % total) + total) % total;
    var item = this.items[this.index];
    this.img.src = item.href;
    this.img.alt = item.caption || '';
    this.caption.textContent = item.caption || '';
    this.count.textContent = total > 1 ? this.index + 1 + ' / ' + total : '';
    var hasSiblings = total > 1;
    this.dialog.querySelector('[data-ed-lb="prev"]').hidden = !hasSiblings;
    this.dialog.querySelector('[data-ed-lb="next"]').hidden = !hasSiblings;
  };

  LightboxController.prototype.step = function (delta) {
    this.show(this.index + delta);
  };

  var controller = null;

  function bind(root) {
    var containers = (root || document).querySelectorAll('[data-ed-lightbox]');
    Array.prototype.forEach.call(containers, function (container) {
      if (container.dataset.edLightboxBound === 'true') return;
      container.dataset.edLightboxBound = 'true';

      container.addEventListener('click', function (event) {
        var link = event.target.closest('.ed-lightbox__item');
        if (!link || !container.contains(link)) return;

        var links = Array.prototype.slice.call(container.querySelectorAll('.ed-lightbox__item'));
        var items = links.map(function (node) {
          return { href: node.getAttribute('href'), caption: node.getAttribute('data-caption') || '' };
        });

        if (!controller) controller = new LightboxController(buildDialog());
        // If <dialog> is unavailable the default navigation still opens the photo.
        if (controller.open(items, links.indexOf(link), link)) event.preventDefault();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
    });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
